import React from "react";
import CreateNft from "../components/createNft";

const CreateNftPage = () => {
  return <CreateNft />;
};

export default CreateNftPage;
